import { render } from "./Team.vue?vue&type=template&id=fd389f82"
const script = {}

import exportComponent from "E:\\vueProject\\richgang-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__